"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.566 2.065c.75-.976 2.117-.976 2.867 0 .77 1.003 1.895 2.648 3.253 5.162 1.26 2.334 1.915 3.925 2.256 4.955.182.549.091 1.092-.21 1.512-.298.414-.78.679-1.333.732-1.193.115-3.04.24-5.4.24-2.36 0-4.206-.125-5.4-.24-.552-.053-1.034-.318-1.332-.732-.301-.42-.392-.963-.21-1.512.34-1.03.996-2.62 2.256-4.955 1.358-2.514 2.483-4.159 3.253-5.162Zm.286 4.14c-.03-.403.157-.796.552-.882a2.78 2.78 0 0 1 .595-.062c.233 0 .432.025.596.062.395.086.583.479.552.882-.057.747-.16 1.967-.272 2.682-.042.265-.207.487-.471.527a2.732 2.732 0 0 1-.405.027c-.163 0-.296-.01-.404-.027-.265-.04-.43-.262-.47-.527-.113-.715-.216-1.935-.273-2.682Zm2.193 5.177a1.045 1.045 0 1 1-2.09 0 1.045 1.045 0 0 1 2.09 0Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWarningIcon);
var _default = exports["default"] = Memo;